import {FontConfig} from '@common/core/services/value-lists.service';

export const BROWSER_SAFE_FONTS: FontConfig[] = [
    {family: 'Impact, Charcoal, sans-serif', category: 'sans-serif'},
    {family: 'Arial, Helvetica Neue, Helvetica, sans-serif', category: 'serif'},
    {family: '"Comic Sans MS", cursive, sans-serif', category: 'Handwriting'},
    {family: 'Century Gothic, sans-serif', category: 'sans-serif'},
    {family: '"Courier New", Courier, monospace', category: 'monospace'},
    {family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', category: 'sans-serif'},
    {family: '"Times New Roman", Times, serif', category: 'serif'},
    {family: '"Lucida Console", Monaco, monospace', category: 'monospace'},
    {family: '"Andele Mono", monospace, sans-serif', category: 'sans-serif'},
    {family: 'Verdana, Geneva, sans-serif', category: 'sans-serif'},
    {family: '"Helvetica Neue", Helvetica, Arial, sans-serif', category: 'sans-serif'},
];
